import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, takeUntil, tap } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';
import {
	bulkDeleteConnectors,
	bulkDeleteConnectorsSuccess,
	ConnectorSelector,
	deleteConnector,
	deleteConnectorSuccess,
} from '../../store';

export enum ConnectorAction {
	Delete = 'delete',
}

export interface IConnectorActionModalData {
	connectorId: number | Array<number>;
	element: string;
	action: ConnectorAction;
}
@Component({
	selector: 'app-connector-action-popup',
	templateUrl: './connector-action-popup.component.html',
	styleUrls: ['./connector-action-popup.component.scss'],
})
export class ConnectorActionPopupComponent<
	T extends IConnectorActionModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly ConnectorAction = ConnectorAction;
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		connectorId: number | Array<number>;
		isMultipleElement: boolean;
		action: ConnectorAction;
		isActionInProgress: boolean;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		private readonly store: Store,
		private readonly connectorSelector: ConnectorSelector,
		private readonly actions$: Actions,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'connector-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.connectorId) &&
				this.modalData.element === '',
			connectorId: this.modalData.connectorId,
			action: this.modalData.action,
			isActionInProgress: this.connectorSelector.getActionInProgress$(),
		});

		this.handleSubscriptions();
	}

	public confirmAction(): void {
		const { connectorId } = this.modalData;
		if (!Array.isArray(connectorId)) {
			return this.store.dispatch(
				deleteConnector({
					connectorId,
				})
			);
		}
		if (connectorId.length === 1) {
			return this.store.dispatch(
				deleteConnector({
					connectorId: connectorId[0],
				})
			);
		}
		return this.store.dispatch(
			bulkDeleteConnectors({
				connectorIds: connectorId,
			})
		);
	}

	private handleSubscriptions(): void {
		this.actions$
			.pipe(
				takeUntil(this.onDestroy$),
				ofType(deleteConnectorSuccess, bulkDeleteConnectorsSuccess),
				tap(() => this.modalService.closeActiveModal())
			)
			.subscribe();
	}
}
